/**
 * Aktuális árfolyamokat lekérdező komponens
 * @author Koppany Kiss 2017.05.17.
 */
import contactServiceModule from './../../services/contact-service';
import vallalatiKapcsolatTemplate from './vallalati-kapcsolat.pug';
import vallalatiKapcsolatForm from './../vallalati-kapcsolat-form/vallalati-kapcsolat-form';
import uuidv1 from 'uuid/v1';
const MODULE_NAME = 'vallalatiKapcsolat';
class VallalatiKapcsolatController {
	constructor(contactService, $rootScope) {
		'ngInject';
		this.contactService = contactService;
		this.uuid = uuidv1;
		this.rootScope = $rootScope;
	}
	$onInit() {
		this.contactService.getVallalatiInit().then(
			(response) => {
				this.getUuid((captchaId) => {
					this.initData = response.data;
					this.initData.captchaId = captchaId;
				});
			}, (error) => {
				this.rootScope.$broadcast('serverError');
				this.error = error;
			});
	}
	sendEmail(model) {
			this.model = model;
			this.contactService.sendEmail(this.model).then(
				(response) => {
					if (response.status == 200) {
						this.success = true;
					}
				}, (error) => {
					this.error = error;
			});
	}
	getUuid(callback) {
		callback(this.uuid());
	}
}

export default angular.module(MODULE_NAME, [contactServiceModule, vallalatiKapcsolatForm])
	.component('vallalatiKapcsolat', {
		controller: VallalatiKapcsolatController,
		template: vallalatiKapcsolatTemplate(),
		bindings: {

		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/vallalati-kapcsolat/vallalati-kapcsolat/vallalati-kapcsolat.js